<coso-replicator-page-header [title]="'History Logs'"></coso-replicator-page-header>
@if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message><div class="d-inline" [innerHTML]="errorMessage"></div></coso-alert-message>
</alert>
}
<div class="mb-3">
  @if (isSaaS === false) {
  <a
    class="btn btn-secondary mr-2"
    data-toggle="tooltip"
    data-placement="top"
    data-original-title="Monitor the status of the replication process in real-time"
    [routerLink]="['../', 'real-time-logs']"
  >
    <span class="icon-stack mr-1" aria-hidden="true">
      <i class="fa fa-fw fa-file-text-o" aria-hidden="true"></i>
      <i class="fa fa-fw fa-refresh icon-stack-smaller-secondary" aria-hidden="true"></i>
    </span>
    View real-time logs
  </a>
  }
  <div class="btn-group dropdown" placement="bottom right">
    <button
      id="btnExportDropdownMenu"
      type="button"
      class="btn btn-primary dropdown-toggle"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      aria-controls="btnExportDropdownMenu"
      aria-label="Open Export options. Press ESC to close the dropdown."
    >
      <span class="fa fa-fw fa-download mr-1" aria-hidden="true"></span>Export
    </button>
    <div class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="dropdownMenu">
      @if (!isSaaS) {
      <button role="menuitem" class="dropdown-item" placement="top" data-toggle="tooltip" data-placement="top" data-original-title="Create a Zip file containing log files" (click)="exportLogsToZip()">
        <span class="fa fa-fw fa-file-archive-o mr-1" aria-hidden="true"></span>Export to Zip
      </button>
      }
      <button
        role="menuitem"
        class="dropdown-item"
        placement="top"
        data-toggle="tooltip"
        data-placement="top"
        data-original-title="Create an Excel file containing log entries from the table"
        (click)="exportLogsToExcel()"
      >
        <span class="fa fa-fw fa-file-excel-o mr-1" aria-hidden="true"></span>Export to Excel
      </button>
    </div>
  </div>
</div>

<div class="d-lg-flex justify-content-lg-end mb-3">
  <button
    type="button"
    class="btn btn-secondary btn-sm mr-2"
    placement="top"
    data-toggle="tooltip"
    data-placement="top"
    data-original-title="Show what filters are available"
    (click)="onPanelOpen()"
    aria-label="Edit Filters. Open advanced filtering panel. Use to filter the content of the table."
  >
    <span class="fa fa-filter mr-1" aria-hidden="true"></span> Edit Filters
  </button>
  <button
    type="button"
    class="btn btn-primary btn-sm mr-2"
    placement="top"
    data-toggle="tooltip"
    data-placement="top"
    data-original-title="Retrieve the latest logs"
    (click)="reload()"
    aria-label="Refresh the content displayed in the table using advanced filters"
  >
    <span class="fa fa-refresh mr-1" aria-hidden="true"></span> Refresh
  </button>
  <form #searchForm="ngForm" (ngSubmit)="onQuickFilterChanged()">
    <div class="input-group input-group-sm mt-lg-0 mt-3">
      <input
        type="text"
        id="search"
        name="search"
        class="form-control"
        placeholder="Search this view"
        aria-label="Search for a string value in Message or Additional Info columns in the table"
        aria-describedby="search-addon"
        [(ngModel)]="quickFilterText"
      />
      <div class="input-group-append">
        <button type="submit" class="btn btn-primary" id="search-addon" aria-label="Start search on table"><i class="fa fa-search" aria-hidden="true" title="Search"></i></button>
        <button type="button" class="btn btn-dark" id="clear-addon" aria-label="Clear" (click)="onQuickFilterClear()"><i class="fa fa-times" aria-hidden="true" title="Clear"></i></button>
      </div>
    </div>
  </form>
</div>

@if ({ isLoading: loadingService.isSpinnerActive$('loadingHistoryLogs') | async }; as loadingState) { @if (!loadingState.isLoading) {
<coso-replicator-logs-table [isRealTime]="false" [rowData]="logEntries" caption="View or monitor detailed logs of the activity"></coso-replicator-logs-table>
} } @if (totalNumberOfItems > 0) {
<coso-paginator
  [rowCount]="totalNumberOfItems"
  [pageSize]="itemsPerPage"
  [resetPageOnRowCountChange]="false"
  [hasFixedRowCount]="hasFixedRowCount"
  (paginationChanged)="onPaginationChanged($event)"
></coso-paginator>
}

<a class="btn btn-dark mt-5" [routerLink]="['/', 'configuration']"><span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Configurations list</a>

<ng-template #advancedFilters>
  <form [formGroup]="filtersFormGroup" id="advancedFiltersForm">
    <div class="form-group">
      <label id="sourceLabel">Source</label>
      <div class="btn-group-toggle" aria-labelledby="sourceLabel">
        <button
          type="button"
          name="database"
          class="btn btn-primary d-block d-sm-inline-block"
          [class.active]="filtersFormGroup.controls.dataSource.value === 'Database'"
          (click)="filtersFormGroup.controls.dataSource.setValue('Database')"
          placement="top"
          data-toggle="tooltip"
          data-placement="top"
          [attr.data-original-title]="isSaas === false ? 'Show logs stored in database' : 'Show logs stored at our platform log storage'"
        >
          @if (isSaas === false) { Database } @else { Platform logs }
        </button>
        <button
          type="button"
          name="dynamics"
          class="btn btn-primary d-block d-sm-inline-block"
          [class.active]="filtersFormGroup.controls.dataSource.value === 'CRM'"
          (click)="filtersFormGroup.controls.dataSource.setValue('CRM')"
          placement="top"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Show logs stored in Dynamics 365"
        >
          Dynamics 365
        </button>
      </div>
    </div>
    <div class="form-group col-md-12 col-lg-6 px-0">
      @if (filterErrorMessage) {
      <alert type="warning" [dismissible]="true" (onClose)="filterErrorMessage = undefined">
        <coso-alert-message>
          <div class="d-inline" [innerHTML]="filterErrorMessage"></div>
        </coso-alert-message>
      </alert>
      }
    </div>
    <div class="form-group col-md-12 col-lg-6 px-0">
      <label for="fromDate">Start Date </label>
      <div class="input-group">
        <input type="date" class="form-control" id="fromDate" name="fromDate" [formControl]="filtersFormGroup.controls.fromDate" aria-describedby="fromTime" />
        <div class="input-group-append">
          <input type="time" class="form-control" id="fromTime" name="fromTime" [formControl]="filtersFormGroup.controls.fromTime" aria-label="Start Time" />
        </div>
      </div>
    </div>
    <div class="form-group col-md-12 col-lg-6 px-0">
      <label for="toDate">End Date</label>
      <div class="input-group">
        <input type="date" class="form-control" id="toDate" name="toDate" [formControl]="filtersFormGroup.controls.toDate" aria-describedby="toTime" />
        <div class="input-group-append">
          <input type="time" class="form-control" id="toTime" name="toTime" [formControl]="filtersFormGroup.controls.toTime" aria-label="End Time" />
        </div>
      </div>
    </div>
    <div class="form-group">
      <label id="logTypesLabel">Log Types</label>
      <div class="btn-group-toggle" role="group" aria-labelledby="logTypesLabel">
        <button
          type="button"
          class="btn btn-primary"
          [formControl]="formArray.controls[0]"
          btnCheckbox
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Internal information used for troubleshooting"
          [btnCheckboxTrue]="LogType.DEBUG"
          [btnCheckboxFalse]="null"
        >
          <span class="fa fa-bug mr-1" aria-hidden="true"></span>Debug
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [formControl]="formArray.controls[1]"
          btnCheckbox
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Informational messages"
          [btnCheckboxTrue]="LogType.INFO"
          [btnCheckboxFalse]="null"
        >
          <span class="fa fa-info-circle mr-1" aria-hidden="true"></span>Info
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [formControl]="formArray.controls[2]"
          btnCheckbox
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Warning messages"
          [btnCheckboxTrue]="LogType.WARN"
          [btnCheckboxFalse]="null"
        >
          <span class="fa fa-exclamation-triangle mr-1" aria-hidden="true"></span>Warning
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [formControl]="formArray.controls[3]"
          btnCheckbox
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Events from Dynamics 365"
          [btnCheckboxTrue]="LogType.EVENT"
          [btnCheckboxFalse]="null"
        >
          <span class="fa fa-bolt mr-1" aria-hidden="true"></span>Dynamics 365 Event
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [formControl]="formArray.controls[4]"
          btnCheckbox
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Error messages"
          [btnCheckboxTrue]="LogType.ERROR"
          [btnCheckboxFalse]="null"
        >
          <span class="fa fa-times-circle mr-1" aria-hidden="true"></span>Error
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [formControl]="formArray.controls[5]"
          btnCheckbox
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Transfer of permissions to SharePoint"
          [btnCheckboxTrue]="LogType.PERMISSION_WRITE"
          [btnCheckboxFalse]="null"
        >
          <span class="fa fa-pencil mr-1" aria-hidden="true"></span>Permission Write
        </button>
      </div>
    </div>
  </form>
</ng-template>
